import React, { useState } from 'react';
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash-es';
import { Checkbox, TextField } from '@fluentui/react';
import JqxProgressBar from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxprogressbar';

import { isNullUndefined, showMessage } from '../../../../../../common/Helpers';
import { __MessageTypes } from '../../../../../../common/Dictionaries';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import MessageBox from '../../../../../Common/Message/MessageBox';

import {
	action_setCompareContracts_ChartData,
	action_setCompareContracts_PanelSegmentValuesSelected,
	action_setCompareContracts_SegmentSelected
} from '../../../../../../reducers/actions/KPI/compareContractsActions';

const SidePanelSetScopeSegments = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const {
		_contratosParaGrafico: selectedContracts,
		_contratosBase: contratosBase,
		_segmentScope: segmentScope,
		_chartData: chartData,
		_segmentSelected: segmentSelected,
		_panelSegmentValues: panelSegmentValues,
		_pilarSeleccionado: pilarSeleccionado,
		_chartDataBaseStructure: chartDataBaseStructure,
	} = useSelector((state) => state.compareContractsScope);

	const inputParam_IsPanelOpen = props.inputParam_IsPanelOpen;
	const inputParam_SetterIsPanelOpen = props.inputParam_SetterIsPanelOpen;

	const [messageConfig, setMessageConfig] = useState({
		message: null,
		messageType: "",
		showMessage: false,
	});

	const [preliminarSegments, setPreliminarSegments] = useState({
		property: '_SCOPE_',
		segments:
			!isNullUndefined(panelSegmentValues) &&
			panelSegmentValues.segmentType === '_SCOPE_' &&
			!isNullUndefined(panelSegmentValues.selectedSegments)
				? panelSegmentValues.selectedSegments
				: []
	});

	const [searchText, setSearchText] = useState('');

	const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);

	const normalizeText = (value) => {
		return (value ?? '')
			.toString()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase()
			.trim();
	};

	const onHideDialog = (ev) => {
		ev.preventDefault();
		inputParam_SetterIsPanelOpen(true);
		hideDialog();
	};

	const onDismissPanel = () => {
		inputParam_SetterIsPanelOpen(false);
	};

	const onHideDialogAndPanel = () => {
		onDismissPanel();
		hideDialog();
	};

	const onClosePanel = () => {
		onDismissPanel();
	};

	const onRenderFooterContent = () => {
		return (
			<Row>
				<Col xl={12} className="message-verybottom-panel-medium">
					<MessageBox
						inputParam_Message={messageConfig.message}
						inputParam_Display={messageConfig.showMessage}
						inputParam_MessageType={messageConfig.messageType}
						inputParam_SetterMessage={setMessageConfig}
					/>
				</Col>

				<Col xl={12}>
					<PrimaryButton
						styles={_global_buttonStyles}
						disabled={preliminarSegments.segments.length === 0}
						onClick={onApplyPanelSegment}
					>
						{t('data-lang-btn-accept')}
					</PrimaryButton>

					<DefaultButton onClick={onClosePanel}>
						{t('data-lang-btn-close')}
					</DefaultButton>
				</Col>
			</Row>
		);
	};

	const getSelectedElementIds = () => {
		return new Set(
			(!isNullUndefined(selectedContracts) ? selectedContracts : contratosBase)
				.map(x => x.elementId)
				.filter(x => !isNullUndefined(x))
		);
	};

	const getFilteredElementsBySelectedContracts = (scopeItem) => {
		const selectedElementIds = getSelectedElementIds();
		const shouldFilterByElementId = selectedElementIds.size > 0;

		return (scopeItem.l_elements || []).filter(element =>
			!shouldFilterByElementId || selectedElementIds.has(element.elementId)
		);
	};

	const buildSeriesFromScopeSegments = (scopeSegments) => {
		const validScopeSegments = scopeSegments.filter(scopeItem =>
			!isNullUndefined(scopeItem.l_elements) &&
			scopeItem.l_elements.length > 0
		);

		const allElements = validScopeSegments.flatMap(scopeItem =>
			getFilteredElementsBySelectedContracts(scopeItem)
		);

		const todosLosPeriodos = [
			...new Set(allElements.map(item => item.periodId))
		].sort((a, b) => Number(a) - Number(b));

		const seriesPorScope = validScopeSegments.map(scopeItem => {
			const elements = getFilteredElementsBySelectedContracts(scopeItem);
			const elementsByPeriod = Object.groupBy(elements, item => item.periodId);

			const data = todosLosPeriodos.map(periodId => {
				const registrosPeriodo = elementsByPeriod[periodId] || [];

				const valoresNumericos = registrosPeriodo
					.map(x => x.scopeValue)
					.filter(x => x !== null && x !== undefined && !isNaN(x))
					.map(Number);

				if (valoresNumericos.length === 0) {
					return null;
				}

				const promedioPeriodo =
					valoresNumericos.reduce((acc, value) => acc + value, 0) / valoresNumericos.length;

				return Math.round(promedioPeriodo);
			});

			return {
				name: scopeItem.name,
				data
			};
		});

		return {
			categories: todosLosPeriodos.map(x => x.toString()),
			series: seriesPorScope
		};
	};

	const onCardClick = (segment) => {
		const exists = preliminarSegments.segments.some(x => x.name === segment.name);

		if (exists) {
			const updatedSegments = preliminarSegments.segments.filter(item => item.name !== segment.name);

			setPreliminarSegments({
				property: '_SCOPE_',
				segments: updatedSegments
			});

			showMessage(setMessageConfig, false, __MessageTypes.WARNING, '');
		} else {
			const aux_segment = cloneDeep(segment);
			aux_segment.auxTitleSegment = segmentScope.filterName;

			setPreliminarSegments({
				property: '_SCOPE_',
				segments: [...preliminarSegments.segments, aux_segment]
			});

			showMessage(setMessageConfig, false, __MessageTypes.WARNING, '');
		}
	};

	const onApplyPanelSegment = () => {
		const aux_chartData = cloneDeep(chartData);

		//const { categories, series } = buildSeriesFromScopeSegments(preliminarSegments.segments);
		const { series } = buildSeriesFromScopeSegments(preliminarSegments.segments);

		const titleSegmentSerie = aux_chartData.contractSeries.filter(item =>
			typeof item.name === "string" &&
			item.name.trim().startsWith("~") &&
			item.name.trim().endsWith("~")
		);

		if (
			segmentSelected.cardSegment === "..." &&
			segmentSelected.propertySegment === "_SCOPE_"
		) {
			const mergedSeries = [...series, ...aux_chartData.contractSeries];

			aux_chartData.contractSeries = mergedSeries.filter((serie, index, self) =>
				index === self.findIndex(x => x.name === serie.name)
			);
		} else {
			aux_chartData.contractSeries = [...series, ...titleSegmentSerie];
		}

		const categories = chartDataBaseStructure.find(x => x.name === "OPF").l_vals.filter(x => x.elementId === 0).map(x => x.periodId.toString())
		aux_chartData.contractCategories = categories;

		dispatch(action_setCompareContracts_ChartData(aux_chartData));

		dispatch(action_setCompareContracts_SegmentSelected({
			titleSegment: segmentScope.filterName,
			cardSegment: "...",
			propertySegment: "_SCOPE_"
		}));

		dispatch(action_setCompareContracts_PanelSegmentValuesSelected({
			titleSegment: segmentScope.filterName,
			segmentType: "_SCOPE_",
			selectedSegments: [...preliminarSegments.segments].sort((a, b) =>
				(b.valueAux ?? -Infinity) - (a.valueAux ?? -Infinity)
			)
		}));

		onDismissPanel();
	};

	const getProgressValue = (segmentItem) => {
		return !isNullUndefined(segmentItem.valueAux) && !isNaN(segmentItem.valueAux)
			? Number(segmentItem.valueAux)
			: 0;
	};

	return (
		<div>
			<Panel
				isOpen={inputParam_IsPanelOpen}
				isLightDismiss={true}
				onLightDismissClick={showDialog}
				onDismiss={onDismissPanel}
				closeButtonAriaLabel={t('data-lang-btn-close')}
				isFooterAtBottom={true}
				onRenderFooterContent={onRenderFooterContent}
				customWidth={PanelType.medium}
				type={PanelType.medium}
				onRenderHeader={() => (
					<Row className='w-100 ps-4'>
						<Col>
							<div style={{
								fontFamily: "Segoe UI",
								fontSize: '20px',
								fontWeight: 600,
								color: 'rgb(50, 49, 48)',
								lineHeight: '27px',
								overflowWrap: 'break-word',
								wordBreak: 'break-word',
								hyphens: 'auto'
							}}>
								<div style={{ fontSize: '20px' }}>
									{t('data-lang-boxname-configsegments')} {pilarSeleccionado.name}
								</div>

								<div style={{ fontSize: '20px', marginTop: 4 }}>
									{segmentScope?.filterName}
								</div>
							</div>
						</Col>
					</Row>
				)}
			>
				<>
					<div
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 10,
							backgroundColor: '#ffffff',
							padding: '12px 0 10px 0',
							borderBottom: '1px solid #edebe9'
						}}
					>
						<Row>
							<Col>
								<TextField
									label="Buscar"
									placeholder="Buscar scope..."
									value={searchText}
									onChange={(ev, value) => setSearchText(value || '')}
								/>
							</Col>
						</Row>
					</div>

					{
						segmentScope &&
						<Row className="pt-3">
							<Col>
								{
									segmentScope.l_segment_values
										.filter(segmentItem =>
											normalizeText(segmentItem.name).includes(normalizeText(searchText))
										)
										.map((segmentItem, indexItemValue) => (
											<Row
												key={indexItemValue}
												className='pb-4 cursor-pointer'
												style={
													segmentSelected.cardSegment === segmentItem.name ? {
														borderWidth: '3px',
														borderColor: segmentScope.color,
														borderStyle: 'revert-layer',
														color: '#000000',
														backgroundColor: '#e3e3e3'
													} : undefined
												}
											>
												<Col>
													<div className='mx-0 px-0 my-auto'>
														<div className='my-1 ps-0 pe-1 my-0 text-start'>
															<Row>
																<Col className='p-0 m-0 my-auto'>
																	<b>{segmentItem.name}</b>
																</Col>

																<Col className='col-auto ms-auto'>
																	<Checkbox
																		checked={preliminarSegments.segments.some(x => x.name === segmentItem.name)}
																		onChange={() => onCardClick(segmentItem)}
																	/>
																</Col>
															</Row>
														</div>
													</div>

													<div className='mx-0 px-0' style={{ width: "100%" }}>
														<div className='d-flex border-end border-top border-bottom'>
															<div className='px-0 my-auto' style={{ width: "37%" }}>
																<div style={{ width: "100%" }}>
																	<div className='my-1 px-0 text-start'>
																		{`${segmentItem.value}${segmentItem.value !== t('no-data') ? '%' : ''}`}
																	</div>
																</div>
															</div>

															<div className='px-0 my-auto' style={{ width: "63%" }}>
																<div style={{ width: "100%" }}>
																	<div className='my-1 px-0 mx-0'>
																		<JqxProgressBar
																			width={'100%'}
																			height={30}
																			value={getProgressValue(segmentItem)}
																			className='custom-progressbar-on'
																		/>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</Col>
											</Row>
										))
								}
							</Col>
						</Row>
					}
				</>

				<Dialog
					hidden={!isDialogVisible}
					onDismiss={onHideDialog}
					dialogContentProps={{
						type: DialogType.normal,
						title: t('data-lang-msg-close-panel'),
					}}
					modalProps={{
						isBlocking: true,
						styles: { main: { maxWidth: 450 } },
					}}
				>
					<DialogFooter>
						<PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
						<DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
					</DialogFooter>
				</Dialog>
			</Panel>
		</div>
	);
};

export default SidePanelSetScopeSegments;